<template>
  <section>
    <figure v-for='(filename, index) in filenames'
            :key='index'
            :style='style(filename)'>
      <ImageLoader :srcset='srcset(page.files[filename])' :sizes='sizes(filename)' />
    </figure>
  </section>
</template>

<script>
export default {
  props: ['page', 'filenames'],
  mounted: function() {
    console.log();
  },
  computed: {
    heightUnit: function() {
      return 100/this.ratios;
    },
    ratios: function(){
      let self = this;
      let ratiosArray = this.filenames.map(function(filename){
        return self.page.files[filename].ratio;
      })
      const reducer = (previousValue, currentValue) => previousValue + currentValue;
      return ratiosArray.reduce(reducer)
    }
  },
  methods: {
    style: function(filename) {
      console.log(this.heightUnit);
      return 'width: ' + this.page.files[filename].ratio*this.heightUnit + '%;';
    },
    sizes: function(filename) {
      return this.page.files[filename].ratio*this.heightUnit + 'vw';
    },
    srcset: function(file) {
      if(file.thumbnails){
        var srcarray = [];
        var sizes = [];
        Object.keys(file.thumbnails).forEach((id) => {
          srcarray.push( file.thumbnails[id] + ' ' + id.replace('w','')+'w');
          sizes.push('(max-width: '+id.replace('w','') + 'px) '+id.replace('w','')+'px');
        });
        return srcarray.join(', ')
      }
    }
  }
}
</script>

<style scoped>
  section {
    display: flex;
    align-items: flex-start;
    align-items: stretch;
    flex-direction: var(--columndirection);
    margin-bottom: 3rem
  }

  section figure {
    width: auto;
    box-sizing: border-box;
    padding-right: 2rem;
    padding-bottom: 2rem;
  }

  section img {
    width: 100%;
  }

  @media screen and (max-width: 800px) {
    figure {
      width: 100% !important;
    }
  }
</style>
